<template>
  <CentralDrawer
    :is-shown="state.isShown"
    :title="`${data.title ?? 'Заполни профиль полностью'}`"
    class="central-drawer"
    @close="close"
  >
    <div v-if="data.image" class="img-wrapper">
      <img :src="data.image" alt="" height="210" width="auto">
    </div>
    <Typography
      variant="v20-700"
      color="primary"
      style="margin: 16px 0"
      center
    >
      {{ data.title ?? 'Заполни профиль' }}
    </Typography>
    <Typography
      variant="v14-400"
      color="secondary"
      style="margin: 16px 0; line-height: 20px; padding: 0 16px"
      center
    >
      {{ data.text ?? 'Чтобы получить доступ к этой функции' }}
    </Typography>
    <AppButton
      v-if="data.text_button"
      full-width
      style="margin: 16px 0"
      @click="fill"
    >
      {{ data.text_button }}
    </AppButton>
  </CentralDrawer>
</template>

<script setup>
import CentralDrawer from '@/components/CentralDrawer.vue'
import {onMounted, reactive} from 'vue'
import AppButton from '@/components/UI/AppButton.vue'
import Typography from '@/components/UI/Typography.vue'
import store from '@/store/store.js'
import {router} from '@/router/router.js'

const props = defineProps({
  data: {
    type: Object,
    default: {},
  }
})

const state = reactive({
  isShown: false,
})

onMounted(() => {
  setTimeout(() => {
    state.isShown = true
    // messageComponent
  }, 50)
})

function close() {
  state.isShown = false
  store.dispatch('app/setMessageComponent', null)
}

function fill() {
  state.isShown = false
  store.dispatch('app/setMessageComponent', null)

  if (props.data.redirect_url) {
    router.push({ path: `/${props.data.redirect_url}` } )
  } else {
    router.push({ name: 'Profile' })
  }
}
</script>

<style lang="scss" scoped>
  .img-wrapper {
    width: 100%;
    height: 207px;
    margin: 32px 0;

    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: visible;
  }
  .central-drawer {
    z-index: 1002!important;
  }
</style>
